// Traduce al español los mensajes de error que devuelve Flespi (vienen en inglés). Lo que no se reconoce se muestra igual, con una introducción en
// español, para no perder la información original.
const REGLAS = [
  [/protocol and ident pair already exists|ident.*already exists|already exists.*ident|duplicate.*ident/i,
    "Ya existe un dispositivo con ese identificador para este tipo de dispositivo. Revisa que no esté registrado ya, en esta u otra cuenta de Flespi."],
  [/(limit|maximum).*(devices?)|devices?.*(limit|maximum)|too many devices/i, "Se alcanzó el límite de dispositivos de la cuenta de Flespi."],
  [/invalid token|token.*(invalid|expired|revoked|not valid)|unauthori[sz]ed|authorization (failed|required)/i, "El token de Flespi no es válido o venció. Avisa al área de sistemas."],
  [/access denied|forbidden|not allowed|permission/i, "No tienes permiso para realizar esta operación en Flespi."],
  [/subaccount.*(not found|does not exist)|(not found|does not exist).*subaccount/i, "La subcuenta no existe en Flespi."],
  [/(device|ident).*(not found|does not exist)|(not found|does not exist).*device|unknown device/i, "No se encontró el dispositivo en Flespi (quizá ya fue eliminado)."],
  [/not found|does not exist|no such/i, "No se encontró lo que se pidió en Flespi."],
  [/too many requests|rate limit|throttl/i, "Flespi recibió demasiadas solicitudes seguidas. Espera unos segundos e intenta de nuevo."],
  [/timeout|timed out|etimedout|econnreset|econnrefused|enotfound|socket hang up|network error/i, "No se pudo conectar con Flespi. Revisa la conexión e intenta de nuevo."],
  [/service unavailable|bad gateway|gateway time|internal server error|server error/i, "Flespi no está disponible en este momento. Intenta de nuevo en unos minutos."],
  [/ident.*(required|missing|empty|must be)|missing.*ident/i, "Falta el identificador del dispositivo o no es válido."],
  [/name.*(required|missing|empty)|missing.*name/i, "Falta el nombre del dispositivo."],
  [/device[_ ]type.*(required|missing|invalid|unknown|not found)/i, "El tipo de dispositivo no es válido."],
  [/messages[_ ]rotate|storage/i, "El almacenamiento (KB) no es válido."],
  [/request failed with status code (\d+)/i, (m) => `La solicitud falló (código ${m[1]}).`],
];

export const traducirErrorFlespi = (texto) => {
  const t = String(texto ?? "").trim();
  if (!t) return "";
  for (const [patron, respuesta] of REGLAS) {
    const m = patron.exec(t);
    if (m) return typeof respuesta === "function" ? respuesta(m) : respuesta;
  }
  // Ya está en español (contiene tildes, ñ o signos de apertura) → se deja tal cual
  if (/[áéíóúñ¿¡]/i.test(t)) return t;
  return `Flespi respondió: "${t}"`;
};

// Mensaje completo de un error de axios que viene de Flespi (puede traer varios errores en una lista)
export const mensajeErrorFlespi = (error, porDefecto = "No se pudo completar la operación") => {
  const payload = error?.response?.data?.error;
  const textos = [];
  if (typeof payload === "string") textos.push(payload);
  else if (payload?.message) textos.push(payload.message);
  else if (Array.isArray(payload?.errors)) payload.errors.forEach((e) => textos.push(e?.reason || e?.message));
  else if (Array.isArray(error?.response?.data?.errors)) error.response.data.errors.forEach((e) => textos.push(e?.reason || e?.message));
  if (!textos.filter(Boolean).length) textos.push(error?.response?.data?.message || error?.message);
  const traducidos = [...new Set(textos.filter(Boolean).map(traducirErrorFlespi))];
  return traducidos.join(" ") || porDefecto;
};
